module.exports = __webpack_public_path__ + "static/SamAdams-Page_17-61da01ff226d763aa975bfdce637cd71.jpg";